export default {
    lang: {
        'vi-vn': 'Tiếng Việt',
        'zh-cn': '中文'
    },
    page: {
        order: 'Đơn hàng',
        revision: 'Sửa đổi',
        guide: 'Hướng dẫn',
        serve: 'Dịch vụ',
        companyProfile: 'Giới thiệu công ty',
        onlineService: 'Dịch vụ trực tuyến',
        financialDetails: 'Chi tiết tài chính',
        recharge: 'Nạp tiền',
        withdraw: 'Rút tiền',
        accountsCanBeReceived: 'Những tài khoản có thể nhận được',
        password: 'Thay đổi mật khẩu đăng nhập',
        passwordFund: 'Thay đổi mật khẩu quỹ',
        SubmitOrder: 'Gửi đơn hàng',
        product: 'Gửi đơn hàng',
        OrderDetail: 'Chi tiết đơn hàng',
        out: 'từ bỏ',
        inviteLink: 'Liên kết giới thiệu',
        treasurePlate: 'Kế hoạch Kho Báu',
        live: 'Trực tiếp',
    },
    side: {
        main: 'Nhà',
        trade: 'Quản lý thương mại',
        tradeOrder: 'Danh sách đơn hàng',
        tradeRecharge: 'Quản lý nạp tiền',
        tradeWithdraw: 'Quản lý rút tiền',
        tradeControl: 'Kiểm soát Thương mại',
        tradeAmount: 'Điều chỉnh số lượng',
        tradeStatistics: 'báo cáo thống kê',
        tradeReport: 'Báo cáo đại lý',
        tradeReportDaily: 'Báo cáo hàng ngày của đại lý',
        tradeReportMonthly: 'Báo cáo hàng tháng của đại lý',
        commodity: 'quản lý hàng hóa',
        commodityList: 'Danh sách hàng hóa',
        commoditySort: 'Phân loại hàng hóa',
        member: 'Quản lý thành viên',
        memberList: 'danh sách thành viên',
        memberSort: 'Cấp thành viên',
        memberLevel: 'Mức trung bình',
        content: 'Quản lý nội dung',
        contentNotice: 'Quản lý thông báo',
        contentText: 'Quản lý văn bản',
        contentAd: 'Băng chuyền trang chủ',
        contentLogo: 'LOGO',
        power: 'Quản lý quyền',
        powerList: 'Quyền truy cập',
        powerAdmin: 'người dùng hệ thống',
        system: 'quản lý hệ thống',
        systemMenu: 'Quản lý menu hệ thống',
        systemParameter: 'Cấu hình tham số hệ thống',
        systemLog: 'Nhật ký vận hành hệ thống'
    },
    but: {
        login: 'Đăng nhập',
        register: 'Đăng ký',
        continue: 'Tiếp tục',
        recharge: 'Nạp tiền',
        withdraw: 'Rút tiền',
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        downloadQr: 'Tải mã QR',
        buyNow: 'Kích hoạt ngay',
        close: 'Đóng',
        upload: 'Chọn ảnh',
        reupload: 'Chọn lại',
        uploading: 'Đang tải lên...',
        save: 'Lưu',
    },
    footer: {
        homePage: 'Trang Chủ',
        product: 'Sản phẩm',
        TreasurePlate: 'Bảng Vàng',
        mine: 'Của tôi',
    },
    title: {
        account: 'Tên tài khoản',
        password: 'Mật khẩu',
        confirmPassword: 'Xác nhận mật khẩu',
        inviteCode: 'Mã mời',
        FundPassword: 'Mật khẩu quỹ',
    },
    placeholder: {
        account: 'Tên người dùng (kết hợp số và chữ cái)',
        password: 'Vui lòng nhập mật khẩu của bạn',
        agree: 'Tôi đồng ý với',
        userAgreement: 'thỏa thuận người dùng',
        user: 'Vui lòng nhập số điện thoại của bạn',
        confirmPassword: 'Vui lòng nhập lại mật khẩu',
        invitation: 'Nhập mã lời mời',
        rechargeAmount: 'Nhập số tiền cần nạp',
        withdrawalAmount: 'Nhập số tiền rút',
        FundPassword: 'Nhập mật khẩu quỹ (VND)',
        firstSettingFund: 'Bạn không cần phải điền nó vào lần cài đặt đầu tiên.',
    },
    text: {
        ShareGuys: '分享给好友',
        MySubordinates: 'Cấp dưới của tôi',
        MyTeam: 'Đội nhóm của tôi',
        totalAccountCount: 'Tổng số tài khoản',
        registerTime: 'Thời gian đăng ký',
        noReferralMembers: 'Chưa có tài khoản đăng ký',
        noMore: 'Không còn nữa',
        subordinatesDesc: 'Tài khoản đăng ký trực tiếp qua liên kết mời của bạn',
        teamDesc: 'Tất cả tài khoản trong chuỗi giới thiệu của bạn, bao gồm cả cấp dưới gián tiếp',
        TodayOrder: '今天订单',
        TodayCommission: '今天佣金',
        MonthRecharge: 'Nạp tháng này',
        MonthCommission: 'Hoa hồng tháng này',
        MonthDirectRecharge: 'Nạp tháng này',
        MonthDirectCommission: 'Hoa hồng tháng này',
        monthDirectRechargeDesc: 'Chi tiết tổng số tiền nạp thành công tháng này từ cấp dưới trực tiếp (theo tài khoản)',
        noMonthDirectRecharge: 'Tháng này chưa có giao dịch nạp từ cấp dưới trực tiếp',
        estimatedCommission: 'Hoa hồng ước tính',
        loading: 'Đang tải...',
        
        workingCapital: 'Vốn lưu động',
        quickAction: 'Thao tác nhanh',
        liveModeLowLatency: 'Độ trễ thấp',
        liveModeStable: 'Ổn định',
        liveFlvUnsupported: 'Trình duyệt không hỗ trợ FLV, hãy dùng Độ trễ thấp hoặc Chrome / Edge',
        liveFlvError: 'Chế độ ổn định lỗi. Quay lại Độ trễ thấp hoặc thử lại sau.',
        liveTapToPlay: 'Chạm vào video để phát',
        liveTapForSound: 'Chạm để bật tiếng',
        amountOfWorkingCapital: 'Số vốn lưu động',
        currentFrozenBalance: 'Số dư đóng băng hiện tại',
        orderToday: 'Đơn hàng hôm nay',
        roseToday: 'Hoa hồng hôm nay',
        allOrders: 'Tất cả đơn hàng',
        totalCommission: 'Tổng hoa hồng',
        order: 'Đơn hàng',
        revision: 'Tài khoản nhận tiền',
        guide: 'Hướng dẫn',
        serve: 'Dịch vụ',
        companyProfile: 'Giới thiệu công ty',
        onlineService: 'Dịch vụ trực tuyến',
        financialDetails: 'Chi tiết tài chính',
        receiveQrTip: 'Vui lòng tải lên mã QR nhận tiền Alipay và WeChat để nền tảng sử dụng',
        uploadAlipayQr: 'Nhấn để tải mã QR Alipay',
        uploadWxQr: 'Nhấn để tải mã QR WeChat',
        receiveQrEmpty: 'Vui lòng chọn mã QR cần tải lên',
        receiveQrTypeError: 'Chỉ hỗ trợ ảnh jpg/png/gif/webp',
        receiveQrSizeError: 'Ảnh không được vượt quá 2MB',
        rechargeAnnouncement: ' Lưu ý: Do lượng thông tin nạp quá lớn nên bạn phải kiểm tra kỹ số thẻ tài khoản trước khi nạp. Nền tảng này thay đổi số tài khoản theo thời gian. Nếu bạn có bất kỳ câu hỏi nào, vui lòng nhấp vào dịch vụ khách hàng trực tuyến！ ',
        rechargeLimit: 'nạp tiền trực tuyến1( 50k đến 300 triệu ) ',
        depositMethodSelect: 'Chọn phương thức nạp tiền',
        depositMethod: 'Phương thức thanh toán',
        serveText: 'Chúc mừng bạn đã đăng nhập thành công !',
        tipRecharge: 'Vui lòng hoàn tất chuyển khoản ngân hàng trong vòng 15 phút',
        AccountBalance: 'Số dư tài khoản',
        withdrawalMin: 'Số tiền rút tối thiểu: 50000 VND ',
        withdrawalMax: 'Số tiền rút tối đa: 999999999 VND ',
        WaitingForAllocation: 'Đang chờ phân phối',
        inviteLinkTip: 'Chia sẻ liên kết hoặc mã QR bên dưới để mời bạn bè đăng ký',
        inviteRegisterLink: 'Liên kết đăng ký mời',
        inviteCodeTip: 'Mã mời là UUID tài khoản của bạn, bạn bè có thể dùng liên kết hoặc nhập thủ công',
        inviteFromLink: 'Bạn đang đăng ký qua liên kết giới thiệu, mã mời đã được điền tự động',
        copySuccess: 'Đã sao chép liên kết',
        copyFailed: 'Sao chép thất bại, vui lòng sao chép thủ công',
        servicePlan: 'Gói dịch vụ',
        monthlyPlan: 'Gói tháng',
        quarterlyPlan: 'Gói quý',
        halfYearPlan: 'Gói nửa năm',
        yearPlan: 'Gói năm',
        monthlyDays: 'Hiệu lực 31 ngày, có thể cộng dồn',
        quarterlyDays: 'Hiệu lực 93 ngày (3 tháng), có thể cộng dồn',
        halfYearDays: 'Hiệu lực 186 ngày (6 tháng), có thể cộng dồn',
        yearDays: 'Hiệu lực 365 ngày (12 tháng), có thể cộng dồn',
        planDaysFallback: 'Hiệu lực {days} ngày, có thể cộng dồn',
        currentValidUntil: 'Hiệu lực đến',
        notActivated: 'Chưa kích hoạt',
        serviceActive: 'Đang hiệu lực',
        serviceExpired: 'Đã hết hạn',
        rmb: 'CNY',
        buying: 'Đang xử lý…',
        buySuccess: 'Kích hoạt thành công',
        subscribeTip: 'Chọn gói và phương thức thanh toán, sau khi thanh toán thời hạn sẽ được cộng dồn.',
        payMethod: 'Phương thức thanh toán',
        payAlipay: 'Alipay',
        payWxpay: 'WeChat Pay',
        payRedirecting: 'Đang chuyển đến trang thanh toán…',
        payCreateFailed: 'Tạo đơn thanh toán thất bại, vui lòng thử lại.',
        payPendingTip: 'Nếu đã thanh toán, thời hạn sẽ cập nhật trong giây lát. Hãy tải lại trang nếu chưa thấy thay đổi.',
        payScanWxTip: 'Vui lòng dùng WeChat quét mã QR bên dưới để thanh toán',
        payScanAlipayTip: 'Vui lòng dùng Alipay quét mã QR bên dưới để thanh toán',
        payWaiting: 'Đang chờ kết quả thanh toán…',
        withdrawMethod: 'Phương thức rút tiền',
        withdrawTrx: 'TRX',
        withdrawUsdt: 'USDT',
        withdrawAvailable: 'Số dư có thể rút',
        withdrawTip: 'Mỗi tháng chỉ được gửi một yêu cầu rút tiền',
        withdrawSelectType: 'Vui lòng chọn phương thức rút tiền',
        withdrawAmountInvalid: 'Vui lòng nhập số tiền hợp lệ',
        withdrawBalanceNotEnough: 'Số dư không đủ',
        withdrawRecord: 'Lịch sử rút tiền',
        withdrawRecordTotal: 'Tổng số bản ghi',
        withdrawApplyTime: 'Thời gian yêu cầu',
        withdrawMonth: 'Tháng',
        withdrawStatusPending: 'Chờ xử lý',
        withdrawStatusSuccess: 'Thành công',
        withdrawStatusFail: 'Thất bại',
        noWithdrawRecords: 'Chưa có lịch sử rút tiền',
        rechargeRecord: 'Lịch sử nạp tiền',
        rechargeRecordTotal: 'Tổng số bản ghi',
        rechargeApplyTime: 'Thời gian đặt',
        rechargeOrderNo: 'Mã đơn',
        rechargeStatusWait: 'Đang chờ',
        rechargeStatusCancel: 'Đã hủy',
        rechargeStatusPending: 'Chờ thanh toán',
        rechargeStatusPaid: 'Đã thanh toán',
        rechargeStatusDone: 'Hoàn tất',
        noRechargeRecords: 'Chưa có lịch sử nạp tiền',
        redEnvelopeTotal: 'Tổng số bao lì xì',
        redEnvelopeGrantTime: 'Thời gian phát',
        redEnvelopeClaimTime: 'Thời gian nhận',
        redEnvelopeUnclaimed: 'Chưa nhận',
        redEnvelopeOpen: 'Mở bao lì xì',
        redEnvelopeScratchHint: 'Giải thưởng ẩn',
        redEnvelopePrize: 'Số tiền thưởng',
        redEnvelopeClaimed: 'Đã nhận',
        noRedEnvelopeRecords: 'Chưa có bao lì xì',
    },
    treasurePlate: {
        becomeTitle: 'Cách trở thành đại lý',
        becomeDesc: 'Chỉ cần mua gói năm là trở thành đại lý. Trong một năm, bạn được hưởng quyền lợi đại lý và nhận hoa hồng.',
        benefitTitle: 'Thu nhập đại lý',
        benefitDesc: 'Thu nhập gồm hai phần: A hoa hồng nạp trực tiếp, B hoa hồng nạp đội nhóm.',
        directTitle: 'A · Hoa hồng nạp trực tiếp',
        directTip: 'Sau khi là đại lý, chia sẻ video cho bạn bè. Khi họ đăng ký và mua gói, bạn nhận hoa hồng theo mức nạp tháng của cấp dưới trực tiếp:',
        teamTitle: 'B · Hoa hồng nạp đội nhóm',
        teamIntro: 'Khi cấp dưới có nhiều tầng, bạn có thể xem thu nhập đóng góp hàng tháng từ từng tầng để tiếp tục phát triển đội.',
        colRank: 'Cấp bậc',
        colAmount: 'Số tiền nạp',
        colSlogan: 'Khẩu hiệu',
        goBuyYear: 'Mua gói năm ngay',
        r1: { title: 'Binh nhì, Chiến sĩ', amount: '≤ 2k', slogan: 'Chiến đấu đơn độc, thử sức' },
        r2: { title: 'Hạ sĩ, Ban trưởng', amount: '> 2k và ≤ 3k', slogan: 'Dẫn ban, lộ tài năng' },
        r3: { title: 'Thiếu úy, Đại đội trưởng', amount: '> 3k và ≤ 4k', slogan: 'Bước vào cấp úy, tự lập' },
        r4: { title: 'Trung úy, Đại đội trưởng', amount: '> 4k và ≤ 5k', slogan: 'Trụ cột trung tầng' },
        r5: { title: 'Thiếu tá, Tiểu đoàn trưởng', amount: '> 5k và ≤ 6k', slogan: 'Chỉ huy tiểu đoàn' },
        r6: { title: 'Thượng úy, Trung đoàn trưởng', amount: '> 6k và ≤ 7k', slogan: 'Một mình gánh vác' },
        r7: { title: 'Trung tá, Lữ đoàn trưởng', amount: '> 7k và ≤ 8k', slogan: 'Chiến trường vững vàng' },
        r8: { title: 'Thượng tá, Sư đoàn trưởng', amount: '> 8k và ≤ 9k', slogan: 'Phong cương đại lão' },
        r9: { title: 'Thiếu tướng, Quân đoàn trưởng', amount: '> 9k và ≤ 10k', slogan: 'Lãnh đạo tập đoàn' },
        r10: { title: 'Thượng tướng, Tư lệnh', amount: '> 10k', slogan: 'Tối cao chỉ huy' },
        t1: 'Khi một tài khoản hoàn tất nạp tiền, 2% số tiền được dùng làm hoa hồng đội nhóm;',
        t2: 'Tìm tài khoản cấp trên của người nạp, trả 25% của 2% làm hoa hồng cho cấp trên;',
        t3: 'Cấp trên tiếp theo nhận 25% phần còn lại, cứ thế lan truyền;',
        t4: 'Phần không còn cấp trên thuộc về nền tảng;',
        t5: 'Người nhận hoa hồng đội nhóm sẽ nhận tin nhắn nội bộ;',
        t6: 'Phải bấm “Nhận” trong tin nhắn mới chuyển vào số dư (trang tin có quảng cáo);',
        t7: 'Có thể xem chi tiết hoa hồng đội nhóm theo tài khoản, thời gian, số tiền, nhưng không thấy cấp dưới đã nhận hay chưa.',
    },
    guideText: {
        no1: '- Mua hàng trực tuyến mang lại sự tiện lợi, chủ động, lựa chọn đa dạng, với các dịch vụ hỗ trợ mua hàng, bán hàng, thanh toán an toàn, giao hàng chuyên nghiệp, Pinggo.vn  không ngừng nỗ lực, cải tiến đáp ứng nhu cầu mua sắm cho người tiêu dùng.',
        no2: '- Sản phẩm của PingGo cam kết chính hãng từ các nhà cung cấp, nhãn hàng với giá cả cạnh tranh. Khi đặt hàng tại PingGo bạn không cần phải lo lắng về chất lượng vì sản phẩm được đăng bán trên sàn đều đã được PingGo chọn lọc và kiểm tra cần thận.',
        no3: '- Chúng tôi phục vụ 7 ngày trong tuần.',
        no4: '- Quy định về công việc :',
        no5: '- Trong quá trình làm việc các thành viên phải làm theo trình tự và đúng với quy định ,yêu cầu của hệ thống .',
        no6: '- Pinggo.vn Xin Trân Trọng Cảm Ơn Các Thành Viên Đã Chung Tay Góp Sức Đồng Hành Cùng Công Ty Cổ Phần Pinggo .',
    },
    revision: {
        password: 'Mật khẩu',
        withdrawalPassword: 'Mật khẩu rút tiền',
        withdrawalAccount:'Tài khoản rút tiền',
        currentPassword: 'Mật khẩu hiện tại',
        aNewPassword: 'Mật khẩu mới',
        confirmYourPassword: 'Xác nhận mật khẩu của bạn',
        realName: 'Tên thật',
        userNAME: 'TÊN ĐĂNG NHẬP',
        bankAccount: 'Tài khoản ngân hàng',
        bankName: 'Tên ngân hàng',
        rechargeAmount: 'Số tiền nạp',
        CompleteRecharge: 'Hoàn tất nạp tiền',
        withdrawalAmount: 'Số tiền rút',
    },
    order: {
        all: 'Tất cả các',
        not: 'Chưa giải quyết',
        complete: 'Hoàn',
        frozen: 'Đông cứng',
    },
    input: {
        Account: 'tên tài khoản',
        Passkey: 'mật khẩu',
        real_name: 'Tên thật',
        bank_user: 'TÊN ĐĂNG NHẬP',
        bank_card: 'Tài khoản ngân hàng',
        bank_id: 'Tên ngân hàng',
        amount: 'Số tiền rút',
        pass_pay: 'Mật khẩu quỹ',
        pass_login: 'Mật khẩu hiện tại',
        new: 'mật khẩu mới',
        confirm: 'Xác nhận mật khẩu',
    },
    pageTxt: {
        order: {
            tab1: 'Tất cả các',
            tab2: 'Chưa giải quyết',
            tab3: 'Hoàn',
            tab4: 'Đông cứng',
            awaiting: 'Đang chờ phân phối ',
        },
        orderDetail: {
            orderValue : 'Giá trị đơn hàng',
            profitMoney: 'Tiền lợi nhuận',
            amountToBeReturned: 'Số tiền phải trả lại',
            codeOrders: 'Mã đơn hàng',
            receivingTime: 'Thời gian nhận',
            orderStatus: 'Trạng thái đặt hàng',
            submit: 'Gửi đơn',
        }
    }
}